module.exports = require("highlight.js");


//////////////////
// WEBPACK FOOTER
// external "highlight.js"
// module id = 2
// module chunks = 0